<script lang="ts">
    import s from './style.module.css';
</script>

<div class={s.svPosition}>
    <slot />
</div>
